import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'context/AuthContext';
import {
  getDictionariesRequest,
  Dictionaries,
  PaymentDictionariesResponse,
  PropertyDictionariesResponse,
} from '@/api';

/**
 * Універсальний хук для завантаження довідників.
 * @param dictionaryName - Назва довідника (наприклад, 'payments', 'tenants').
 */
function useGetDictionaries<T = Dictionaries>(dictionaryName: string) {
  const { isAuthenticated } = useAuth();

  return useQuery<T>({ // Явно вказуємо тип для useQuery
    // Ключ запиту тепер динамічний і включає назву довідника
    queryKey: ['dictionaries', dictionaryName],
    // Викликаємо універсальну функцію API
    queryFn: async () => {
      const response = await getDictionariesRequest<T>(dictionaryName);
      return response.data;
    },
    // Запит активний тільки якщо користувач авторизований і є назва довідника
    enabled: isAuthenticated && !!dictionaryName,
    // Кешуємо дані на 5 хвилин, щоб уникнути зайвих запитів
    staleTime: 1000 * 60 * 5,
  });
}

export default useGetDictionaries;
